// extracted by mini-css-extract-plugin
export default {"DraggableCard":"bfh_a"};